import { createAction, props } from '@ngrx/store';
import { UserModel } from 'app/core/mips/common/models/user.model';
export const setLoggedInUser = createAction('[LoggedInUser] Set LoggedInUser', props<{ user : UserModel }>());
export const clearLoggedInUser = createAction('[LoggedInUser] Clear LoggedInUser');
